module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-01.9b786cf1.jpg";